import serviceProject from "../serviceProject";
import api from "../../../api";

const SourceAdapterMessage = {
  ...serviceProject,
  resource: "source-adapter-messages",
  testFilter(
    params = {},
    onSuccess = () => {},
    onError = () => {},
    errorHandler = () => {}
  ) {
    return api
      .post(`/${this.resource}:test-filter`, params)
      .then(res => {
        onSuccess(res.data);
        errorHandler({});
        return res;
      })
      .catch(res => {
        errorHandler(res.response.data.errors);
        onError(res);
      });
  }
};
export default SourceAdapterMessage;
